import { Navigate, Route, Routes } from "react-router-dom";
import PageTitle from "../components/PageTitle";
import Dashboard from "../pages/Dashboard";
import DieStatus from "../pages/Master/DieStatus";
import Location from "../pages/Master/Location";
import Customer from "../pages/Master/Customer";
import Alloy from "../pages/Master/Alloy";
import OrderStatus from "../pages/Master/OrderStatus";
import OrderPlanView from "../pages/OrderPlanView/OrderPlanView";
import DieMaster from "../pages/DieManagement/DieMaster";
import SalesOrderMaster from "../pages/SalesOrders/SalesOrderMaster";
import Foundry from "../pages/Foundry/FoundryMaster";
import Spectro from "../pages/Master/SpectroMaster";
import AllStocks from "../pages/RawMaterial/AllStocks";
import InProduction from "../pages/InProduction";
import QC from "../pages/QC";
import Aging from "../pages/Aging";
import ToolingSize from "../pages/Master/ToolingSize";
import DieType from "../pages/Master/DieType";
import Packing from "../pages/Packing";
import SupplierDie from "../pages/Master/SupplierDie";
import RawMaterial from "../pages/Master/RawMaterial";
import MaterialInward from "../pages/RawMaterial/MaterialInward";
import Login from "../components/Auth/Login";
import Users from "../pages/Master/Users";
import MenuMaster from "../pages/Master/MenuMaster";
import MenuPermission from "../pages/Settings/MenuPermission";
import UnitConversion from "../pages/Master/UnitConversion";
import ToolingEntry from "../pages/Master/ToolingEntry";
import ToolingType from "../pages/Master/ToolingType";
import NalcoMaster from "../pages/Master/NalcoMaster";
import SetUp from "../pages/Master";
import FurnaceMaster from "../pages/Master/FurnaceMaster";
import PressMaster from "../pages/Master/PressMaster";
import DieAllocation from "../pages/DieManagement/DieAllocation";
import Department from "../pages/Master/Department";
import Incharge from "../pages/Master/Incharge";
import Category from "../pages/Master/Category";
import DieUnloadReason from "../pages/Master/DieUnloadReason";
import Series from "../pages/Master/Series";

// const ProtectedRoute = ({ children }) => {
//   const token = Cookies.get("token");
//   return token ? children : <Navigate to="/login" replace />;
// };

const ProtectedRoute = ({ children }) => {
  const user = sessionStorage.getItem("user");
  return user ? children : <Navigate to="/login" replace />;
};

const AppRoutes = () => (
  <Routes>
    <Route
      path="/login"
      element={
        <>
          <PageTitle title="Login" />
          <Login />
        </>
      }
    />
    <Route
      path="/dashboard"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Dashboard" />
            <Dashboard />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Set-Up" />
            <SetUp />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/die-management/die-status"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Die Status" />
            <DieStatus />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/department"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Department" />
            <Department />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/category"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Category" />
            <Category />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/series"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Series" />
            <Series />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/dieUnloadReason"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="DieUnloadReason" />
            <DieUnloadReason />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/incharge"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Incharge" />
            <Incharge />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/die-management/supplier-die"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="supplier-die" />
            <SupplierDie />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/die-management/location"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="location" />
            <Location />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/die-management/toolingSize"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="ToolingSize" />
            <ToolingSize />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/die-management/dieType"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="DieType" />
            <DieType />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/die-management/die-master"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="die-master" />
            <DieMaster />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/die-management/die-allocation"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="die-allocation" />
            <DieAllocation />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/sales-customer"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="sales-customer" />
            <Customer />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/sales-orders/alloy"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="alloy" />
            <Alloy />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/sales-orders/order-status"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="order-status" />
            <OrderStatus />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/sales-orders/unit-conversion"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="unit-conversion" />
            <UnitConversion />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/sales-orders/order-master"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="order-master" />
            <SalesOrderMaster />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/order-plan-view"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Order Plan View" />
            <OrderPlanView />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/raw-material"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Raw-Material" />
            <RawMaterial />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/material-inward"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Material-Inward" />
            <MaterialInward />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/all-stock"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="All-Stocks" />
            <AllStocks />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/foundry"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Foundry" />
            <Foundry />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/spectro"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Spectro" />
            <Spectro />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/in-production"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="In-Production" />
            <InProduction />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/qc"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="QC" />
            <QC />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/aging"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Aging" />
            <Aging />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/packing"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Packing" />
            <Packing />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/tooling-Entry"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Tooling-Entry" />
            <ToolingEntry />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/tooling-type"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Tooling-Type" />
            <ToolingType />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/furnace"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Furnace" />
            <FurnaceMaster />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/press"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Press" />
            <PressMaster />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/settings/users"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Users" />
            <Users />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/settings/menu-master"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="MenuMaster" />
            <MenuMaster />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/settings/menu-permission"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="MenuPermission" />
            <MenuPermission />
          </ProtectedRoute>
        </>
      }
    />
    <Route
      path="/master/settings/nalco-master"
      element={
        <>
          <ProtectedRoute>
            <PageTitle title="Nalco-Master" />
            <NalcoMaster />
          </ProtectedRoute>
        </>
      }
    />
    <Route path="*" element={<Navigate to="/dashboard" replace />} />
  </Routes>
);

export default AppRoutes;
